import React from 'react';

const Logo = (props) => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 1000 1000" version="1.1" xmlns="http://www.w3.org/2000/svg">      <defs>
        <linearGradient id="MyGradient"
                    x1="0%" y1="0%"
                    x2="0%" y2="100%"
                    spreadMethod="pad"
        >
          <stop offset="5%" stopColor="gray" />
          <stop offset="95%" stopColor="darkgray" />
        </linearGradient>
      </defs>
            <g transform="matrix(0.257003,0,0,0.296912,-1326.14,0.890736)">
                <g className="logomark__fill" >
                    <g transform="matrix(4.79326,0,0,4.14899,-147.906,-4214.71)" fill={props.fill || "#fff"}>
                        <circle cx="1526" cy="1421" r="69" />
                    </g>
                    <g transform="matrix(2.51357,0,0,2.17571,16300.9,-1417.21)" fill={props.fill || "#fff"}>
                        <path d="M-2926.62,1722.54C-3042.42,2001.69 -3320.09,2198 -3634,2198C-4051.25,2198 -4390,1851.18 -4390,1424C-4390,996.818 -4051.25,650 -3634,650C-3320.09,650 -3042.42,846.305 -2926.62,1125.46L-3359.72,1284.03C-3374.12,1254.85 -3393.46,1227.49 -3417.74,1203.21C-3537.1,1083.85 -3730.9,1083.85 -3850.26,1203.21C-3969.62,1322.57 -3969.62,1516.38 -3850.26,1635.74L-3634,1852L-3417.74,1635.74C-3395.59,1613.59 -3377.55,1588.87 -3363.62,1562.54L-2926.62,1722.54Z" />
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default Logo;
